import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton } from '@mui/material';

type Props = {
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
};

const DeleteButton = ({ onClick, disabled }: Props) => {
  return (
    <IconButton
      size="small"
      className="delete-button"
      color="error"
      onClick={onClick}
      disabled={disabled}
    >
      <DeleteIcon fontSize="small" />
    </IconButton>
  );
};

export default DeleteButton;
